import { startOfYear } from 'date-fns'

export const priorityOptions = [
  { label: 'Trending', value: 'trending' },
  {
    label: 'Most Posts',
    value: 'most-posts',
  },
]

export const maxDateRange = {
  from: startOfYear(new Date()),
  to: new Date(),
}
